module.exports = __webpack_public_path__ + "img/collect.cdcb720e.svg";